import { sendAnalytics } from '@audio-network/analytics'
import {
	Divider,
	MobileMenu as MobileMenuComponent,
	MobileMenuControlButton,
	NavBar,
	NavBarItem,
	Text,
} from '@audio-network/componentlibrary'
import { useTranslation } from 'next-i18next'
import React from 'react'

import regionalSites from '@/constants/regionalSites'
import { usePersistSearchScrollPosition } from '@/pages/track/searchkeyword/index.hooks'
import sessionStore from '@/stores/sessionStore'

const newProjectModalId = 'new-project-modal'

const MobileMenu = (): JSX.Element => {
	const user = sessionStore((state) => state.session?.user)
	const { t } = useTranslation(['navigation'])
	const { clearSearchScrollPosition } = usePersistSearchScrollPosition()

	const handleClick = (noun: string): void => {
		if (noun === 'Search') {
			/**
			 * Clean up any scroll positioning when navigating to search
			 *
			 * See Results.utils.ts for set up.
			 */
			clearSearchScrollPosition()
			document.getElementById('main-content')?.scrollTo(0, 0)
		}

		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	return (
		<>
			<MobileMenuControlButton aria-label="Open menu" />
			<MobileMenuComponent id="mobile-menu">
				<NavBar>
					<NavBarItem
						content={t('music')}
						href="/track/searchkeyword"
						onClick={() => handleClick('Search')}
					/>
					<NavBarItem
						content={t('playlists')}
						href="/playlist-hub"
						onClick={() => handleClick('Playlists')}
					/>
					<NavBarItem
						content={t('albums')}
						href="/albums"
						onClick={() => handleClick('Albums')}
						data-navitem="albums"
					/>
					<NavBarItem
						content={t('collections')}
						href="/collections"
						onClick={() => handleClick('Collections')}
					/>
					<NavBarItem
						content={t('sound-effects')}
						href="/sound-effects"
						onClick={() => handleClick('Sound Effects')}
					/>
				</NavBar>
				<Divider />
				{user && (
					<>
						<NavBar>
							<NavBarItem
								content={t('favourites')}
								href="/favourites"
								onClick={() => handleClick('Favourites')}
							/>
							<NavBarItem
								content={t('projects')}
								href="/project/all"
								onClick={() => handleClick('Projects')}
							/>
							<NavBarItem
								content={t('new-project-create-project')}
								onClick={() => handleClick('Create Project')}
								{...{
									command: 'show-modal',
									commandfor: newProjectModalId,
								}}
							/>
						</NavBar>
						<Divider />
					</>
				)}
				<NavBar>
					<NavBarItem
						content={t('contact-us')}
						href="/contact"
						target="_blank"
						onClick={() => handleClick('Contact us')}
					/>
					<NavBarItem
						content={t('blog')}
						href="/blog"
						target="_blank"
						onClick={() => handleClick('Blog')}
					/>
					<NavBarItem
						content={t('privacy-and-cookies')}
						href="/privacy"
						target="_blank"
						onClick={() => handleClick('Privacy')}
					/>
					<NavBarItem
						content={t('terms')}
						href="/terms"
						target="_blank"
						onClick={() => handleClick('Terms')}
					/>
				</NavBar>
				<Divider />
				<NavBar>
					{Object.entries(regionalSites).map(([key, value]) => (
						<NavBarItem
							key={key}
							content={
								<Text>
									{value.language}
									<Text color="textSecondary" display="block" variant="bodyS">
										{value.region}
									</Text>
								</Text>
							}
							href={value.href}
							aria-label={value.label ?? null}
							// Currently no analytics for regional sites?
						/>
					))}
				</NavBar>
			</MobileMenuComponent>
		</>
	)
}

export default MobileMenu
